import { useIntegrationConfigurationQuery } from "@/apollo/types";
import { useDataWarehouse } from "@/providers/account";

/**
 * Whether a full sync into this workspace's data warehouse can keep the rows the source no longer
 * returns. Offering the setting where the warehouse cannot honour it would promise deletes we
 * never capture - the API rejects it there too.
 */
export function useDataWarehouseSupportsSoftDeletes(): boolean {
  const dataWarehouse = useDataWarehouse();
  const { data } = useIntegrationConfigurationQuery({
    variables: { id: dataWarehouse.integrationId ?? "", isDatawarehouse: true },
    skip: !dataWarehouse.integrationId,
  });

  return !!data?.integrationConfiguration.supportsSoftDeletes;
}
